import type { Block } from '../../../../types/proposal-blocks';

type Data = Extract<Block, { type: 'chart' }>;

export function ChartBlock({ block }: { block: Data }) {
  const maxValue = Math.max(...block.data.map(d => d.value), 1);

  return (
    <div className="my-6">
      <h3 className="text-base font-semibold text-proposal-fg1 mb-4">{block.title}</h3>

      {block.chart_type === 'bar' && (
        <div className="space-y-2">
          {block.data.map((d, i) => (
            <div key={i} className="flex items-center gap-3">
              <span className="text-[12px] text-proposal-fg2 w-24 shrink-0 text-right">{d.label}</span>
              <div className="flex-1 bg-proposal-bg3 rounded h-6 overflow-hidden">
                <div
                  className="h-full bg-proposal-accent rounded transition-all"
                  style={{ width: `${(d.value / maxValue) * 100}%` }}
                />
              </div>
              <span className="text-[12px] font-proposal-mono text-proposal-fg2 w-12">{d.value}</span>
            </div>
          ))}
        </div>
      )}

      {block.chart_type === 'pie' && (
        <div className="flex flex-wrap gap-3 justify-center">
          {block.data.map((d, i) => {
            const total = block.data.reduce((s, x) => s + x.value, 0);
            const pct = total > 0 ? Math.round((d.value / total) * 100) : 0;
            return (
              <div key={i} className="bg-proposal-bg2 border border-proposal-border rounded-p-lg px-4 py-3 text-center min-w-[100px]">
                <div className="text-lg font-bold text-proposal-accent font-proposal-mono">{pct}%</div>
                <div className="text-[11px] text-proposal-fg3">{d.label}</div>
              </div>
            );
          })}
        </div>
      )}

      {block.chart_type === 'line' && (
        <div className="flex items-end gap-1 h-32 border-b border-l border-proposal-border pl-2 pb-2">
          {block.data.map((d, i) => (
            <div key={i} className="flex-1 flex flex-col items-center justify-end">
              <div
                className="w-3 bg-proposal-accent rounded-t transition-all"
                style={{ height: `${(d.value / maxValue) * 100}%` }}
              />
              <span className="text-[9px] text-proposal-fg3 mt-1 truncate max-w-full">{d.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
